<template>

    <div>

        <transition name="modal">
            <v-modal-logout v-if="showModal === 'logout'"></v-modal-logout>
        </transition>

        <v-panel class="maxw-600">
            <template #title>Enter an Authy Token</template>
            <template #body>
                <v-alert :message="error" />
                <div id="authy-input" class="mb-30">
                    <v-loader v-if="loading" size="lg"></v-loader>
                    <form v-else class="d-flex" @submit.prevent="validate" autocomplete="off">
                        <v-input v-for="num in 6"
                            :ref="'num-'+num"
                            :id="'num-'+num"
                            :key="num"
                            :model="token[num - 1]"
                            class="num"
                            maxlength="1"
                            @keyup.native="onKeyUp(num)">
                        </v-input>
                    </form>
                </div>
                <p class="small text-center mb-0"><a href="#" @click.prevent="logout">Log Out</a></p>
            </template>
        </v-panel>

    </div>

</template>

<style scoped lang="scss">

    #authy-input {
        align-items: center;
        display: flex;
        justify-content: center;
        margin: 0 auto;
        position: relative;
        height: 60px;
        width: 320px;
        form {
            height: 100%;
        }
        .num {
            flex-grow: 1;
            font-size: 20px !important;
            height: 100% !important;
            margin-left: 5px;
            text-align: center;
            &:first-child {
                margin: 0;
            }
        }
    }

</style>

<script>

import AuthyApi from '@api/AuthyApi';
import ModalLogout from '@modals/misc/ModalLogout';
import UserApi from '@api/UserApi';

export default {

    components: {
        'v-modal-logout': ModalLogout,
    },

    data() {
        return {
            loading: false,
            error: null,
            token: ['', '', '', '', '', ''],
        }
    },

    mounted() {
        document.getElementById('num-1').focus();
        document.getElementById('authy-input').addEventListener('keydown', this.onKeyDown);
    },

    beforeDestroy() {
        document.getElementById('authy-input').removeEventListener('keydown', this.onKeyDown);
    },

    methods: {

        onKeyUp(num) {
            if (num === 6) {
                this.validate(this.token.join(''));
            }
        },

        onKeyDown(e) {
            e.preventDefault();
            if ((e.keyCode >= 48 && e.keyCode <= 57) || (e.keyCode >= 96 && e.keyCode <= 105)) {
                // Number
                for (let i = 1; i <= 6; i++) {
                    if (e.target.id === 'num-' + i) {
                        this.token[i - 1] = e.key;
                        document.getElementById('num-' + i).value = e.key;
                        if (i !== 6) {
                            document.getElementById('num-' + (i + 1)).focus();
                        } else {
                            document.getElementById('num-6').value = e.key;
                        }
                    }
                }
            } else if (e.keyCode === 9 || e.keyCode === 39) {
                // Tab or right
                for (let i = 1; i <= 6; i++) {
                    if (e.target.id === 'num-' + i) {
                        let num = (i === 6) ? 1 : i + 1;
                        document.getElementById('num-' + num).focus();
                    }
                }
            } else if (e.keyCode === 37) {
                // Left
                for (let i = 1; i <= 6; i++) {
                    if (e.target.id === 'num-' + i) {
                        let num = (i - 1 >= 1) ? i - 1 : 6;
                        document.getElementById('num-' + num).focus();
                    }
                }
            } else if (e.keyCode === 8) {
                // Backspace
                for (let i = 1; i <= 6; i++) {
                    if (e.target.id === 'num-' + i) {
                        this.token[i - 1] = '';
                        if (i - 1 >= 1) {
                            if (!document.getElementById('num-' + i).value) {
                                document.getElementById('num-' + (i - 1)).value = '';
                            }
                            document.getElementById('num-' + (i - 1)).focus();
                        }
                        document.getElementById('num-' + i).value = '';
                    }
                }
            } else if (e.keyCode === 13) {
                // Enter
                this.validate(this.token.join(''));
            }
        },

        validate(token) {
            if (token.length < 6) return;
            this.loading = true;
            AuthyApi.validate(token)
                .then((response) => {
                    this.loading = false;
                    this.getUser();
                }, (error) => {
                    this.loading = false;
                    this.error = error.response.data.message;
                    this.$nextTick(() => {
                        document.getElementById('num-1').focus();
                    });
                });
        },

        getUser() {
            this.loading = true;
            UserApi.getUser()
                .then((response) => {
                    this.loading = false;
                    if (this.$store.getters.inviteToken) {
                        this.$router.push({ name: 'accept-invite', params: { token: this.$store.getters.inviteToken } });
                    } else {
                        this.$router.push({ name: !this.$store.getters.companyOnboarded ? 'install' : 'console' });
                    }
                }, (error) => {
                    this.loading = false;
                    this.error = error.response.data.message;
                });
        },

        logout() {
            this.$store.commit('showModal', 'logout');
        },

    },

}

</script>
